module.exports = __webpack_public_path__ + "static/media/creative.582f0421.png";